"use strict";
exports.__esModule = true;
exports.BALANCE_OUT_OF_RANGE_SCHEDULE_SUCCESS = exports.SKIP_MONTH = exports.OVERWRITE_AMOUNT_VALIDATION = exports.EMBED_BTL_OR_BTH = void 0;
exports.EMBED_BTL_OR_BTH = {
    SERVICE_ISSUE: 'Service issue',
    HEADER: 'Your rent balance is {{higherOrLower}} than estimated',
    BODY: 'Please enter the exact amount you’d like Flex to pay your property this month.',
    BILL_DETAILS: 'Rent bill detais',
    ORIGINAL: 'Original estimate',
    ACTUAL: 'Actual rent balance',
    TOTAL: 'Total due to property',
    RENT_AMOUNT: 'Rent payment amount',
    SKIP_MONTH: 'Don’t use Flex this month',
    CTA: 'Update payment amount'
};
exports.OVERWRITE_AMOUNT_VALIDATION = {
    MORE_THAN_ACTUAL: 'Rent payment amount cannot exceed actual rent balance',
    LESS_THAN_ACTUAL: 'Rent payment amount cannot be less than actual rent balance',
    MUST_EQUAL: 'Rent payment amount must equal total due to property'
};
exports.SKIP_MONTH = {
    SERVICE_ISSUE: 'Service issue',
    HEADER: 'Are you sure you don’t want Flex to pay your rent?',
    BODY1: 'If you continue, Flex will not pay your rent bill this month. ',
    BODY2: 'You will be responsible for paying your full rent directly to your property.',
    BODY3: 'Your Flex plan will otherwise remain unchanged.',
    BODY4: 'By proceeding, you have read and understand the above.',
    BODY5: 'This cannot be reversed.',
    BACK: 'Back',
    CONFIRM: 'Confirm'
};
exports.BALANCE_OUT_OF_RANGE_SCHEDULE_SUCCESS = {
    BODY_1: 'We’ve successfully updated your rent payment amount to {{amount}}. It may take up to an hour for the service issue status to be resolved.',
    BODY_2: 'Keep an eye on your email or download the Flex app to stay up-to-date with your status.',
    HEADER: 'All set!',
    NOTICE: 'Download the Flex app to manage your account, adjust payment options and receive important notifications.'
};
